import apiRequest from './apiRequest';

export type AdminUserManagementSearchResult =
  | {
      type: 'user';
      user: Record<string, unknown>;
      organization?: Record<string, unknown>;
    }
  | {
      type: 'organization';
      organization: Record<string, unknown>;
    }
  | {
      type: 'service';
      serviceAccount: { serviceID: string; serviceName: string; organizationID: string };
      organization?: Record<string, unknown>;
    };

export default async function getAdminUserManagementSearch(query: string) {
  const params = new URLSearchParams({ q: query });
  return apiRequest<AdminUserManagementSearchResult>(
    'user',
    `/admin/userManagement/search?${params.toString()}`,
  );
}
